import { SpotOrderRecord, cancelSpotOrdersById } from 'api/v1/spot'
import toastify from 'components/Toastify'
import { useCallback } from 'react'
import { useAppDispatch } from 'store'
import { useAccountId } from 'store/account/hooks'
import { updateCancelSpotPendingIds } from 'store/spot/actions'
import { useCancelSpotPendingIds } from 'store/spot/hooks'

export function useCancelOrder() {
  const dispatch = useAppDispatch()
  const cancelPendingIds = useCancelSpotPendingIds()
  const accountId = useAccountId()

  return useCallback(
    async (orderItem: SpotOrderRecord) => {
      const { id } = orderItem
      const isExist = cancelPendingIds?.find((item) => item === id)
      if (isExist) {
        return
      }
      dispatch(updateCancelSpotPendingIds([...cancelPendingIds, id]))
      try {
        await cancelSpotOrdersById(accountId!, id)
      } catch (error) {
        toastify.error(error.response.data.message)
        const res = cancelPendingIds.filter((item) => item !== id)
        dispatch(updateCancelSpotPendingIds(res))
      }
    },
    [dispatch, accountId, cancelPendingIds],
  )
}
